import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const Cricket = () => {
  return (
    <SportsLayoutComp name={'Cricket'}/>
  )
}

export default Cricket